import { ArrowRight } from '@icons';
import { useState } from 'react';
import { Button } from 'react-bootstrap';
import NewPasswordForm from './NewPasswordForm';

export default function AuthSection({ profileFromApi }) {
	const [isEditing, setIsEditing] = useState(false);

	return (
		<>
			<h2
				style={{
					textTransform: 'none',
					fontSize: '32px',
					fontWeight: 700,
					margin: '36.8px 0 56px 0',
					lineHeight: '100%',
				}}
			>
				Autenticazione
			</h2>

			<div className={`simple-box scenarita custom-simple_box`}>
				{!isEditing ? (
					<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
						<div style={{ display: 'grid', gap: '8px' }}>
							<h3
								style={{
									fontSize: '18px',
									fontWeight: 700,
									lineHeight: '28px',
									marginBottom: 0,
								}}
							>
								Password
							</h3>

							<p
								style={{
									lineHeight: '28px',
									marginBottom: 0,
								}}
							>
								•••••••••••••••
							</p>
						</div>
						<Button
							onClick={() => {
								setIsEditing(true);
							}}
							style={{
								border: 'none',
								backgroundColor: 'transparent',
								color: '#06797F',
								fontWeight: 500,
								textTransform: 'none',
							}}
						>
							Modifica
							<ArrowRight style={{ marginLeft: '12px', color: '#06797F' }} />
						</Button>
					</div>
				) : (
					<NewPasswordForm profileFromApi={profileFromApi} callback={() => setIsEditing(false)} />
				)}
			</div>
		</>
	);
}
